<section class="hucu-dialog hucu-dialog--sprint">
  <header class="hucu-dialog__header">
    <div>
      <p class="hucu-dialog__eyebrow">Planificación ágil</p>
      <h2>{{ esModificar ? 'Editar sprint' : 'Agregar sprint' }}</h2>
      <p>Defina el periodo, la etapa y la relación con sprints anteriores.</p>
    </div>
    <button type="button" mat-icon-button class="hucu-dialog__close" (click)="onNoClick()"
      aria-label="Cerrar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="datosform" autocomplete="off" mat-dialog-content class="hucu-dialog__content hucu-dialog__form">
    <div class="hucu-dialog__form-grid">
      <mat-form-field appearance="outline" class="hucu-dialog__field hucu-dialog__field--wide">
        <mat-label>Nombre</mat-label>
        <textarea aria-label="Nombre" maxlength="100" matInput [(ngModel)]="objectSprint.nombre" formControlName="nombre"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hucu-dialog__field">
        <mat-label>Fecha de inicio</mat-label>
        <input aria-label="Fecha de inicio" matInput [matDatepicker]="picker" readonly [(ngModel)]="objectSprint.fechaInicio"
          [max]="objectSprint.fechaFin" formControlName="fechaInicio" (dateChange)="validarFechaInicio($event)">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hucu-dialog__field">
        <mat-label>Fecha de fin</mat-label>
        <input aria-label="Fecha de fin" matInput [matDatepicker]="picker2" readonly [(ngModel)]="objectSprint.fechaFin"
          [min]="minDateFin" formControlName="fechaFin" (dateChange)="validaFechaFin($event)">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hucu-dialog__field">
        <mat-label>Etapa</mat-label>
        <mat-select [(ngModel)]="objectSprint.idFase" id="stage" name="stage"
          (selectionChange)="onSelectEtapa($event)" formControlName="etapa">
          <mat-option *ngFor="let stage of filterStage | async" [value]="stage.id">
            {{ stage.descripcion }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hucu-dialog__field">
        <mat-label>Sprint anterior</mat-label>
        <mat-select [(ngModel)]="objectSprint.idIteracion" id="sprint" name="sprint" formControlName="sprintAnterior">
          <mat-option *ngFor="let sprint of filterSprint | async" [value]="sprint.id">
            {{ sprint.nombre }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="esModificar" appearance="outline" class="hucu-dialog__field">
        <mat-label>Estatus</mat-label>
        <mat-select formControlName="estatus" [(ngModel)]="objectSprint.estatus"
          (ngModelChange)="validarEstatusSprint($event)">
          <mat-option *ngFor="let enum of estatus" [value]="enum.estatus">
            {{ enum.estatusConvertido }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <footer class="hucu-dialog__footer">
    <button type="button" mat-button class="app-form-btn app-form-btn--secondary" (click)="onNoClick()">Cancelar</button>
    <button type="button" mat-button class="app-form-btn app-form-btn--primary" (click)="saveSprint()"
      [disabled]="datosform.invalid">
      Guardar sprint
    </button>
  </footer>
</section>
